// eslint-disable-file
<template lang="pug">
  el-row(:gutter="10")
    el-col(:md='8')
      .container-perfil.column.margin
        img.item-perfil.img-perfil(src="../../../../assets/icons/employee.svg")
        span.item-perfil {{ usuario ? usuario.toUpperCase() : '-' }}
        span.item-perfil {{ totalLabel }}
    el-col(:md='8')
      app-plotly(nomeDiv="graficoProdutividadeAnalista", :dados="graficoDados", :layout="layout", :centralizarGrafico="true")
    el-col(:md='8')
      section.container.column.margin
        .item(v-for="item in dadosWithColors")
          el-tag.color-text-tag(size="small", :color="item.color") {{ item.quantidade }}
          span {{ item.tipoProcesso }}
</template>

<script>
import AppPlotly from '@/components/AppPlotly'

import { tipoCadastroDescricao } from '../../../../utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    usuario: {
      required: true
    },
    dadosLabels: {
      required: true
    }
  },

  data () {
    return {
      dados: [],
      colors: ['#F2A74B', '#038C65', '#1C79A6', '#0F4786', '#A61C5C',
        '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
      loading: true
    }
  },

  computed: {
    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  //eslint-disable-line
        return []
      }
      const graficoDados = [{
        values: [],
        labels: [],
        domain: { column: 0 },
        name: 'Produtividade por Analista',
        hoverinfo: 'label+percent',
        textinfo: 'none',
        hole: 0.58,
        type: 'pie',
        marker: {
          colors: []
        }
      }]

      this.dadosWithColors.forEach((dado) => {
        graficoDados[0].labels.push(dado.tipoProcesso)
        graficoDados[0].values.push(dado.quantidade)
        graficoDados[0].marker.colors.push(dado.color)
      })

      return graficoDados
    },
    hasData () {
      return !_.isEmpty(this.dados)  //eslint-disable-line
    },
    layout () {
      return {
        showlegend: false,
        height: 450,
        width: 300,
        annotations: [
          {
            font: {
              size: 30
            },
            showarrow: false,
            text: this.totalDados,
            x: 0.5,
            y: 0.5
          }
        ],
        margin: {
          l: 50,
          r: 50,
          t: 25,
          b: 50,
          pad: 0
        }
      }
    },

    totalDados () {
      const total = this.dadosLabels.reduce((total, dado) => total + dado.quantidade, 0)
      this.$emit('totalProcessos', total)
      return total
    },

    dadosWithColors () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        tipoProcesso: tipoCadastroDescricao[dado.codigo],
        color: this.colors[index]
      }))
    },

    totalLabel () {
      const plural = this.totalDados > 1 ? 's' : ''
      return `${this.totalDados} Processo${plural} analisado${plural}`
    }
  },

  methods: {
    getIcon () {
      return 'static/assets/icons/speaker_notes_add.svg'
    }
  }
}
</script>
<style lang="scss" scoped>

  .row {
    flex-direction: row;
  }
  .column {
    flex-direction: column;
  }

  .container {
    max-width: 400px;
    margin: 0 auto;
    display: flex;
    text-align: center;
    padding-left: 40px;
  }

  .container-perfil {
    margin: 0 auto;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .item-perfil {
    flex: 1;
    padding: 0.5em;
  }

  .img-perfil {
    width: 150px;
    height: 200px;
  }

  .item {
    flex: 1;
    margin: 5px;
    text-align: left;
    font-size: 1em;
    .color-text-tag{
      color: #ffffff;
      padding-left: 30px;
      padding-right: 30px;
      width: 90px;
      text-align: center;
    }
    span {
       font-size: 1em;
       margin-right: 0.5em;
    }
  }
  .margin{
    margin-top: 6.5em;
  }

  .icone-imagem {
    width: 100px;
  }

  .d-flex {
    display: flex;
  }

</style>



// WEBPACK FOOTER //
// src/screens/produtividade/components/produtividadeAnalista/GraficoProdutividade.vue